<div class="no-data-wrapper">
  <div class="no-data-card">
    <div class="icon">
      📭
    </div>
    <h2>No Slots Available for Booking, Yet.</h2>
    <p>
      We couldn't find any data to display right now.
      Please check again later or try refreshing.
    </p>
   </div>
</div>